import { render, staticRenderFns } from "./productAllocation.vue?vue&type=template&id=3d0ffc8d&scoped=true"
import script from "./productAllocation.vue?vue&type=script&lang=js"
export * from "./productAllocation.vue?vue&type=script&lang=js"
import style0 from "./productAllocation.vue?vue&type=style&index=0&id=3d0ffc8d&prod&scoped=true&lang=css"
import style1 from "./productAllocation.vue?vue&type=style&index=1&id=3d0ffc8d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d0ffc8d",
  null
  
)

export default component.exports